var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
// start readmore
$(document).on('click','#read-more',function(){
    var $this = $(this);
    $this.parents('.buttonmob').siblings().children('.product-detail').children().children('#truncated-product-description').slideToggle();
    $this.parents('.buttonmob').siblings().children('.product-detail').children().children('#truncated-product-description').siblings('#product-description').slideToggle();
    // $(this).parents('#truncated-product-description').slideUp();
    // $(this).parents('#truncated-product-description').siblings('#product-description').slideDown();
});
// end readmore
// start readless
$(document).on('click','#read-less',function(){
    $(this).parent().slideUp();
    $(this).parent('#product-description').siblings('#truncated-product-description').slideDown();
})
// end readless
// start ingredients  
$(document).on('click','.ingredilist h3',function(){
    if($(this).next('div').css('display') == 'none'){
      $(this).next('div').slideDown();
      $(this).children('.plus_o').hide();
      $(this).children('.minus_o').show();
    }
    else{
      $(this).next('div').slideUp();
      $(this).children('.plus_o').show();
      $(this).children('.minus_o').hide();
    }
  });
// end ingredients

// start additem
$(document).on('click','.add-cart-btn',function(){
    var lisarid = $(this).siblings('input[name="id"]').val();
    var $this = $(this);
    function getottl(){
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        
        if(cart.items.length == 0){
          $('.ttl0prc').hide();
          $('.clsnumbitms0').hide();
        } 
        if(cart.items.length > 0){
          $('.ttl0prc').show();
          $('.ttl0prc').children('h4').children('.carttotlpr').text(Shopify.formatMoney(cart.original_total_price));
          $('.clsnumbitms0').show();
          var count = 0;
          while(cart.items.length > 0 ) {
            item = cart.items.shift();
            var count = parseInt(count) + parseInt(item.quantity);
          }
          $('.clsnumbitms0').html(count);
        } 
      }
    })
  }

  function ifnotexist(lisarid){
     $.ajax({
      type: 'POST',                            
      url: '/cart/add.js',
      dataType: 'json',                              
      data: {quantity:1,id:lisarid},           
      success: function(response){
        $('.itemdadd').addClass('itbtm');
        setTimeout(function(){
          $('.itemdadd').removeClass('itbtm');
        },5000);
        $this.text('Added');
        var ttitldd = $this.parents('.buttonmob').siblings().children('.product-detail').children('h2').text();
        var tturldd = $this.parents('.buttonmob').siblings().children('.product-detail').children('h2').children('input').val();
        var ttvriddd = $this.siblings('input').val();
        var iimmgg =  $this.parents('.buttonmob').siblings().children('.product-container').children().children('img').attr('src');
        var itmprc = $this.parents('.buttonmob').siblings().children('.product-detail').children('.lstprc').text();
          $('.addeditemshw').append('<div class="gridadded"><div class="img"><img src="'+iimmgg+'"></div><div class="meta"><h2>'+ttitldd+'</h2><p class="itempric">'+itmprc+'</p><div class="qtyitmscrt"><input type="button" value="-" class="qtyminus1"><input type="number" class="quantity-selector cart-number" value="1" min="0"><input type="button" value="+" class="qtyplus1"></div><p class="removitemdv"><a href="javascript:void(0)" class="removitem" data-id="'+lisarid+'">Remove</a></p></div></div>');
          $('.addednameurlprprop').append('<input class="pro" type="hidden" name="contact[product_name]" value="'+ttitldd+'" data-variantid="'+ttvriddd+'" data-qty="1">');
          // $('.addednameurlprprop').append('<input class="pro" type="hidden" name="contact[product_url]" value="'+tturldd+'">');
          // $('.addednameurlprprop').append('<input class="pro" type="hidden" name="contact[product_variant_id]" value="'+ttvriddd+'">');
        
        setTimeout(function(){
          $this.text('Add to Purchase Email');
        },5000);
        getottl();
      }
     })
  }
  function updateqtyitm(item_id,prsinpls){
    $.ajax({
      type: 'POST',                            
      url: '/cart/change.js',
      dataType: 'json',                              
      data: {quantity:prsinpls,id:item_id },           
      success: function(cart){
        $('.ttl0prc').children('h4').children('.carttotlpr').text(Shopify.formatMoney(cart.original_total_price));
        $('.itemdupdt').addClass('itbtm');
        setTimeout(function(){
          $('.itemdupdt').removeClass('itbtm');
        },3000)
        getottl();
      }                             
    });
  }
   $.ajax({
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        var item,ii=0;
        var rv = false;
        var itmid = 0;
        var itmqty = 0;
        while(cart.items.length > 0 ) {
          item = cart.items.shift();
          if(item.id == lisarid){
            rv = true;
            itmid = item.id;
            itmqty = parseInt(item.quantity)+parseInt(1);
          }
          else{
            rv = false;
          }
        }
          if(rv == true){
            $('.gridadded').each(function(){
              var grdid = $(this).children('.meta').children('.removitemdv').children().attr('data-id');
              if(grdid == itmid){
              $(this).children('.meta').children('.qtyitmscrt').children('.cart-number').val(itmqty);
              }
            })
            updateqtyitm(lisarid,itmqty);
          }
          else{
            ifnotexist(lisarid);
          }
       
      }
   })
  
});
// end additem

// start removeitem
$(document).on('click','.removitem',function(){
  var itmmid = $(this).attr('data-id');
  var $this = $(this);
  function getottl(){
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        if(cart.items.length == 0){
          $('.ttl0prc').hide();
          $('.clsnumbitms0').hide();
        } 
        if(cart.items.length > 0){
          $('.ttl0prc').show();
          $('.ttl0prc').children('h4').children('.carttotlpr').text(Shopify.formatMoney(cart.original_total_price));
          $('.clsnumbitms0').show();
          var count = 0;
          while(cart.items.length > 0 ) {
            item = cart.items.shift();
            var count = parseInt(count) + parseInt(item.quantity);
          }
          $('.clsnumbitms0').html(count);
        } 
      }
    })
  }
   $.ajax({
      type: 'POST',                            
      url: '/cart/change.js',
      dataType: 'json',                              
      data: {quantity:0,id:itmmid },           
      success: function(cart){
        $this.parent().parent().parent('.gridadded').remove();
        $('.itemdremove').addClass('itbtm');
        setTimeout(function(){
          $('.itemdremove').removeClass('itbtm');
        },3000);
        getottl();
      }                             
    });
})
// end removeitem

//start cartsubmitform
$(document).on('click','.submitbtnlist',function(){
  $('.pro_form_1').slideToggle();
  $('.submitbtnlist').css({'color':'#fff'});
  if($(window).width() <= 840){
    $('.subpursd').toggleClass('subpursd00');
  }
});
var cur_url = window.location.href;
if(cur_url.indexOf("?contact_posted=true") > -1){
  setTimeout(function(){
    $(".pro_form_1").slideDown();
  },800);
  if($(window).width() <= 840){
    setTimeout(function(){
      $('.silist').trigger('click');
       $('.subpursd').addClass('subpursd00');
    },800);
  }
}
//end cartsubmitform

//start plusqtycart
$(document).on('click','.qtyplus1',function(){
  var $thisqtyplus = $(this);
  var addqty0 = $thisqtyplus.siblings('.cart-number').val();
  var addedpls = parseInt(addqty0)+parseInt(1);
  $thisqtyplus.siblings('.cart-number').val(addedpls);
  var getitmid = $(this).parent().siblings('.removitemdv').children('.removitem').attr('data-id');
  function getottl(){
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          if(cart.items.length == 0){
            $('.ttl0prc').hide();
            $('.clsnumbitms0').hide();
          } 
          if(cart.items.length > 0){
            $('.ttl0prc').show();
            $('.ttl0prc').children('h4').children('.carttotlpr').text(Shopify.formatMoney(cart.original_total_price));
            $('.clsnumbitms0').show();
            var count = 0;
            while(cart.items.length > 0 ) {
              item = cart.items.shift();
              var count = parseInt(count) + parseInt(item.quantity);
            }
            $('.clsnumbitms0').html(count);
          } 
        }
      })
    }
  $.ajax({
      type: 'POST',                            
      url: '/cart/change.js',
      dataType: 'json',                              
      data: {quantity:addedpls,id:getitmid },           
      success: function(cart){
        $('.ttl0prc').children('h4').children('.carttotlpr').text(Shopify.formatMoney(cart.original_total_price));
        $('.itemdupdt').addClass('itbtm');
        setTimeout(function(){
          $('.itemdupdt').removeClass('itbtm');
        },3000)
        getottl();
      }                             
    });
})
//end plusqtycart

//start minusqtycart
$(document).on('click','.qtyminus1',function(){
  var $thisqtyminus = $(this);
  var minqty0 = $thisqtyminus.siblings('.cart-number').val();
  if(minqty0 >= 0){
  var minedpls = parseInt(minqty0)-parseInt(1);
  $thisqtyminus.siblings('.cart-number').val(minedpls);
  }
  var getitmid = $(this).parent().siblings('.removitemdv').children('.removitem').attr('data-id');
  function getottl(){
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          if(cart.items.length == 0){
            $('.ttl0prc').hide();
            $('.clsnumbitms0').hide();
          } 
          if(cart.items.length > 0){
            $('.ttl0prc').show();
            $('.ttl0prc').children('h4').children('.carttotlpr').text(Shopify.formatMoney(cart.original_total_price));
            $('.clsnumbitms0').show();
            var count = 0;
            while(cart.items.length > 0 ) {
              item = cart.items.shift();
              var count = parseInt(count) + parseInt(item.quantity);
            }
            $('.clsnumbitms0').html(count);
          } 
        }
      })
    }
  if(minedpls == 0){
    $.ajax({
      type: 'POST',                            
      url: '/cart/change.js',
      dataType: 'json',                              
      data: {quantity:0,id:getitmid },           
      success: function(cart){
        $thisqtyminus.parent().parent().parent('.gridadded').remove();
        $('.itemdremove').addClass('itbtm');
        setTimeout(function(){
          $('.itemdremove').removeClass('itbtm');
        },3000);
        getottl();
      }                             
    });
  }
  else{
  $.ajax({
      type: 'POST',                            
      url: '/cart/change.js',
      dataType: 'json',                              
      data: {quantity:minedpls,id:getitmid },           
      success: function(cart){
        $('.ttl0prc').children('h4').children('.carttotlpr').text(Shopify.formatMoney(cart.original_total_price));
        $('.itemdupdt').addClass('itbtm');
        setTimeout(function(){
          $('.itemdupdt').removeClass('itbtm');
        },3000)
        getottl();
      }                             
    });
      
  }
})
//end minusqtycart

// start mobile cart
$(document).on('click','.silist',function() {
  $('.addeditems').show();
  $('.addeditems').addClass('addeditems00');
});
$(document).on('click','.closedmoim',function() {
  $('.addeditems').hide();
  $('.addeditems').removeClass('addeditems00');
});

$(document).on('click','.inquery_div #contact_form .btn',function(e){
  e.preventDefault();
  function orderphp(draftOrder,getnmcntct,getemcntct){
  $.ajax({
      type: 'POST',
      url: "https://dev.dermsilktreatments.com/order_create.php",
      data: {draftOrder:draftOrder,customerName:getnmcntct,customerEmail:getemcntct},
      dataType: "json",
      success: function(response) {
        console.log(response.responseText);
        $('.ntemsg').addClass('shwithntrms');
        $('.ntemsgerr').removeClass('shwithntrms');
        // setTimeout(function(){
        //   $('.ntemsg').removeClass('shwithntrms');
        // },2000)
        $('#contact_form').submit();
      },
    error: function(xhr, status, error) {
      console.log(error);
      $('#contact_form').submit(); 
       //$('.ntemsgerr').addClass('shwithntrms');
       $('.ntemsg').removeClass('shwithntrms');
    }
      // error: function(response) {
      //   console.log(response.responseText);
      //   $('.ntemsgerr').addClass('shwithntrms');
      // }
    });
  }
  var getnmcntct = $('#ContactFormName').val();
  var getemcntct = $('#ContactFormEmail').val();
  var data = [];
  var item;
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      while( cart.items.length > 0 ) {
       item = cart.items.shift();
        data.push({'variant_id':item.id,'quantity':item.quantity});
      }
      //data.push({'customerName':getnmcntct,'customerEmail':getemcntct});
      var draftOrder = JSON.stringify(data);
      orderphp(draftOrder,getnmcntct,getemcntct);
     },
    error: function(response) {
      console.log(response.responseText);
    }
  });
});

  

